import React from 'react';
import { Mentions } from 'antd';
import { MentionProps } from 'antd/lib/mentions';

export const getMentions = Mentions.getMentions;

export type MentionsProps = MentionProps;

const ProMentions: React.FC<MentionsProps> = React.forwardRef<
  any,
  MentionsProps
>((props, ref) => {
  const { children, ...resProps } = props;

  return (
    <Mentions ref={ref} {...resProps}>
      {children}
    </Mentions>
  );
});

export default ProMentions;
